export default "__VITE_ASSET__DSS9sZXM__"